import GdaBanner from './GdaBanner';

export default GdaBanner;
